import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

import { createTheme } from '@mui/material/styles';

export const components = {
  MuiCardContent: {
    styleOverrides: {
      root: () => ({
        // boxShadow: 12,
        '&:last-child': {
          paddingBottom: 4
        }
      })
    }
  },
  MuiStack: {
    defaultProps: {
      useFlexGap: true,
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: () => ({
        borderRadius,
      })
    }
  },
  MuiButtonGroup: {
    styleOverrides: {
      root: () => ({
        boxShadow: 'none',
      })
    }
  },
  MuiButton: {
    styleOverrides: {
      root: ({ ownerState, ...theme }) => {
        // const mode = theme?.palette?.mode || 'dark'
        const lineHeight = ownerState.size === 'small' ? '1.2rem' : null
        const fontSize = ownerState.size === 'small' ? '14px' : '16px'
        // const light = ownerState.color === 'success'
        //   ? '#10a010'
        //   : ownerState.color === 'error'
        //     ? '#a01034'
        //     : ownerState.color === 'info'
        //       ? '#3f5a9d'
        //       : '#180C0C99'
        // const dark = ownerState.color === 'success'
        //   ? '#095a09'
        //   : ownerState.color === 'error'
        //     ? '#ae4848'
        //     : ownerState.color === 'info'
        //       ? '#293b66'
        //       : '#180C0C99'
        // const backgroundColor = mode === 'dark' ? dark : light

        return {
          // fontFamily: fontFamilies.buttonFont,
          fontSize,
          // fontWeight: 'light',
          textTransform: 'none',
          // boxShadow: '4px 4px #8d8d8d54',
          width: 'auto',
          // minWidth: 75,
          borderRadius,
          // backgroundColor,
          lineHeight,
          '&:hover': {
            // backgroundColor: emphasize(backgroundColor, 0.05),
            // filter: 'contrast(1.5)',
            // boxShadow: '5px 5px #8d8d8d58',
          }
        }
      }
    }
  },
  // MuiInputBase: {
  //   styleOverrides: {
  //     root: () => ({
  //       borderRadius,
  //       overflow: 'hidden',
  //     }),
  //     select: () => ({
  //       borderRadius,
  //       overflow: 'hidden',
  //     })
  //   },
  // },
  MuiAlert: {
    styleOverrides: {
      root: ({ ownerState }) => {
        return {
          borderRadius,
          boxShadow: '5px 5px #8d8d8d54',
          color: 'white',
          backgroundColor:
            ownerState?.severity === 'info'
              ? `#2d4590`
              : ownerState?.severity === 'error'
                ? '#ae4848'
                : '#228b22',
          // '& svg': {
          //   fill: 'white'
          // }
        }
      }
    }
  },
  // MuiPaginationItem: {
  //   styleOverrides: {
  //     root: () => ({
  //       border: 'none',
  //       borderRadius,
  //       borderColor: '#272831',
  //       boxShadow: '2px 2px #797a84',
  //       height: '45px',
  //       lineHeight: '45px'
  //     })
  //   }
  // },
  // MuiAccordion: {
  //   styleOverrides: {
  //     root: () => ({
  //       backgroundColor: 'rgba(0,0,0,0.5)',
  //       color: 'white'
  //     })
  //   },
  // },
  // MuiAccordionDetails: {
  //   styleOverrides: {
  //     root: () => ({
  //       padding: '4px'
  //     })
  //   },
  // },
  // MuiListItem: {
  //   styleOverrides: {
  //     root: () => ({
  //       padding: '8px 12px'
  //     })
  //   },
  // },
  MuiChip: {
    styleOverrides: {
      // root: () => {
      //   // const backgroundColor = ownerState?.color === 'primary' ? 'rgba(255, 255, 255, .5)' : 'inherit'
      //   // color: theme => theme.palette.mode === "dark" ? "white" : "black",
      //   // backgroundColor: theme => theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(255, 255, 255, 0.8)",
      //   return {
      //     // backgroundColor,
      //     // borderRadius: borderRadius * 2
      //   }
      // },
      avatar: () => ({
        color: 'currentcolor'
      })
    },
  },
  // test this
  // MuiAvatarGroup: {
  //   styleOverrides: {
  //     root: () => ({
  //       // borderRadius,
  //       flexDirection: 'row',
  //       // justifyContent: 'center'
  //     }),
  //   },
  // },
}

export const lightPalette = {
  mode: 'light',
  error: {
    main: '#b24343'
  },
  warning: {
    main: '#f5a800'
  },
  primary: {
    main: '#b4b4b4',
  },
  secondary: {
    main: '#ccc',
  },
  background: {
    default: '#ccc',
    header: '#ccc',
    body: '#dcdcdc',
    paper: '#ccc',
    footer: '#ccc'
  },
  divider: '#ccc',
  // secondary: {
  //   main: PALETTE.HIGHLIGHT,
  // },
  // background: {
  //   paper: PALETTE.PAPER,
  // }
}
export const darkPalette = {
  mode: 'dark',
  error: {
    main: '#b24343'
  },
  primary: {
    main: '#666',
  },
  secondary: {
    main: '#b4b4b4',
  },
  divider: '#ccc',
  background: {
    default: '#444',
    header: '#111',
    body: '#333',
    paper: '#000',
    footer: '#000'
  }
}

export const Theme = createTheme({
  components,
})

export default Theme
